(function($) {

	'use strict';

	var init = function() {

        $( ".skills__wrapper__items__skill" ).hover(function() {
            $( this ).toggleClass("hover");
          });

	};
	


	$(document).ready(function() {
		init();
	});

})(jQuery);
